import {useMemo} from 'react'

import {useBoardElementRef} from '../provider/contexts'
import {subscribeToReaderInput} from './reader-movement'

export type BoardReaderMovement = {
  /**
   * Calls `listener` on reader gestures; reflows do not report. Scoped to the board's own
   * element inside a `BoardProvider`, and page-wide outside one, where there is no board to
   * measure a gesture against.
   */
  subscribeToInput: (listener: () => void) => () => void
}

export function useBoardReaderMovement(): BoardReaderMovement {
  const boardElementRef = useBoardElementRef()

  return useMemo(
    () => ({
      subscribeToInput: listener => subscribeToReaderInput(listener, boardElementRef),
    }),
    [boardElementRef],
  )
}
